import { render, staticRenderFns } from "./BusinessEntityDetails.vue?vue&type=template&id=55d04d6c&scoped=true&"
import script from "./BusinessEntityDetails.vue?vue&type=script&lang=js&"
export * from "./BusinessEntityDetails.vue?vue&type=script&lang=js&"
import style0 from "./BusinessEntityDetails.vue?vue&type=style&index=0&id=55d04d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d04d6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55d04d6c')) {
      api.createRecord('55d04d6c', component.options)
    } else {
      api.reload('55d04d6c', component.options)
    }
    module.hot.accept("./BusinessEntityDetails.vue?vue&type=template&id=55d04d6c&scoped=true&", function () {
      api.rerender('55d04d6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/BusinessEntities/BusinessEntityDetails.vue"
export default component.exports